<template>
  <v-container>
    <v-overlay :value="overlay" z-index="100">
      <v-progress-circular
        :size="50"
        color="grey lighten-4"
        indeterminate
      ></v-progress-circular>
    </v-overlay>

    <v-layout row justify-center class="ma-0">
      <v-flex xs12>
        <v-tabs>
          <v-tab>Cadastro</v-tab>
          <v-tab-item>
            <v-card>
              <v-card-title class="align-start">
                <div class="flex-fill">
                  <div class="mb-3 d-flex text-center">
                    <template>
                      <v-dialog v-model="dialog" persistent max-width="500">
                        <template v-slot:activator="{ on }">
                          <v-btn
                            elevation="0"
                            text
                            color="primary"
                            v-on="on"
                            :disabled="
                              evento.desativar == 'N' && evento.status == 'R'
                                ? true
                                : false
                            "
                          >
                            <v-icon left>mdi-calendar-clock</v-icon>
                            <span>Agendar</span>
                          </v-btn>
                        </template>
                        <v-card min-width="500">
                          <v-card-title class="headline"
                            >Quando o evento deve ser enviado?</v-card-title
                          >
                          <v-card-text>
                            <template>
                              <v-container>
                                <v-row>
                                  <v-col cols="12" lg="6">
                                    <v-menu
                                      ref="menu1"
                                      v-model="menu1"
                                      :close-on-content-click="false"
                                      transition="scale-transition"
                                      offset-y
                                      full-width
                                      max-width="290px"
                                      min-width="290px"
                                    >
                                      <template v-slot:activator="{ on }">
                                        <v-text-field
                                          v-model="dateFormatted"
                                          label="Data"
                                          persistent-hint
                                          prepend-icon="event"
                                          @blur="
                                            date = parseDate(dateFormatted)
                                          "
                                          v-on="on"
                                        ></v-text-field>
                                      </template>
                                      <v-date-picker
                                        v-model="date"
                                        no-title
                                        @input="menu1 = false"
                                      ></v-date-picker>
                                    </v-menu>
                                  </v-col>
                                  <v-col cols="12" sm="6">
                                    <v-menu
                                      ref="menu"
                                      v-model="menu2"
                                      :close-on-content-click="false"
                                      :nudge-right="40"
                                      :return-value.sync="time"
                                      transition="scale-transition"
                                      offset-y
                                      max-width="290px"
                                      min-width="290px"
                                    >
                                      <template v-slot:activator="{ on }">
                                        <v-text-field
                                          v-model="time"
                                          label="Hora"
                                          prepend-icon="access_time"
                                          readonly
                                          v-on="on"
                                        ></v-text-field>
                                      </template>
                                      <v-time-picker
                                        v-if="menu2"
                                        v-model="time"
                                        width="290"
                                        format="24hr"
                                        @click:minute="$refs.menu.save(time)"
                                      ></v-time-picker>
                                    </v-menu>
                                  </v-col>
                                </v-row>
                              </v-container>
                            </template>
                          </v-card-text>
                          <v-card-actions>
                            <v-spacer></v-spacer>
                            <v-btn
                              color="grey darken-1"
                              text
                              @click="dialog = false"
                              >Cancelar</v-btn
                            >
                            <v-btn color="blue darken-1" text @click="agendar"
                              >Confirmar</v-btn
                            >
                          </v-card-actions>
                        </v-card>
                      </v-dialog>
                    </template>
                    <v-btn
                      v-if="evento.status === 'C' || evento.status == 'E'"
                      class="mr-2"
                      elevation="0"
                      text
                      color="primary"
                      :disabled="
                        evento.desativar === 'S' || evento.status == 'E'
                          ? true
                          : false
                      "
                      @click="desativar('R')"
                    >
                      <v-icon left>mdi-checkbox-marked-outline</v-icon>
                      <span>Reprovar</span>
                    </v-btn>
                    <v-btn
                      v-if="evento.status === 'R' || evento.status === 'P'"
                      class="mr-2"
                      elevation="0"
                      text
                      color="primary"
                      :disabled="
                        evento.desativar === 'S' || evento.status == 'E'
                          ? true
                          : false
                      "
                      @click="desativar('C')"
                    >
                      <v-icon left>mdi-checkbox-marked-outline</v-icon>
                      <span>Aprovar</span>
                    </v-btn>

                    <v-btn
                      class="mr-2"
                      elevation="0"
                      text
                      color="primary"
                      @click="desativarPorId"
                    >
                      <template v-if="evento.desativar === 'S'">
                        <v-icon left>mdi-eye</v-icon>
                        <span>Ativar</span>
                      </template>
                      <template v-else>
                        <v-icon left>mdi-eye-off</v-icon>
                        <span>Desativar</span>
                      </template>
                    </v-btn>
                    <v-btn
                      class="mr-2"
                      elevation="0"
                      text
                      color="primary"
                      :to="`/eventos/${evento.id}/editar`"
                      :disabled="evento.desativar === 'S' ? true : false"
                    >
                      <v-icon left>mdi-pencil</v-icon>
                      <span>Editar</span>
                    </v-btn>
                    <v-btn
                      class="mr-2"
                      elevation="0"
                      text
                      color="error"
                      @click="$refs.delete.request(evento.id)"
                      :disabled="evento.status == 'E'"
                    >
                      <v-icon left>mdi-delete</v-icon>
                      <span>Excluir</span>
                    </v-btn>
                    <v-spacer />
                    <v-btn
                      elevation="0"
                      color="primary"
                      @click="enviar"
                      :disabled="
                        evento.status == 'R' ||
                        evento.desativar == 'S' ||
                        evento.status == 'P'
                          ? true
                          : false
                      "
                    >
                      <span>Enviar</span>
                      <v-icon right small>mdi-send</v-icon>
                    </v-btn>
                  </div>
                  <v-divider />
                  <header class="mb-2">
                    <p class="title primary--text mt-3 mb-0">
                      <v-icon color="primary" left
                        >mdi-file-document-edit</v-icon
                      >
                      <span>{{ evento.titulo }}</span>
                    </p>
                    <v-chip small class="mr-2">
                      <v-icon small left>mdi-calendar</v-icon>
                      <span>{{ moment(evento.data).format('LL') }}</span>
                    </v-chip>
                    <v-chip
                      small
                      v-for="t in evento.turma"
                      :key="t.id"
                      class="mr-2"
                    >
                      <v-icon small left>mdi-google-classroom</v-icon>
                      <span>
                        {{
                          [
                            _.result(t, 'serie.nome'),
                            _.result(t, 'nome'),
                            _.result(t, 'serie.nivel.nome')
                          ].join(' ')
                        }}
                      </span>
                    </v-chip>
                    <v-chip v-if="evento.desativar === 'S'" dark avatar small>
                      <v-icon left small>mdi-eye-off</v-icon>
                      <span>Desativado</span>
                    </v-chip>
                    <v-chip
                      v-if="evento.status === 'P' && evento.desativar === 'N'"
                      color="warning"
                      avatar
                      small
                    >
                      <v-icon left small>mdi-timer-sand</v-icon>
                      <span>Pendente</span>
                    </v-chip>
                    <v-chip
                      v-else-if="
                        evento.status === 'A' && evento.desativar === 'N'
                      "
                      color="primary"
                      avatar
                      small
                    >
                      <v-icon left small>mdi-clock-outline</v-icon>
                      <span>Agendado</span>
                    </v-chip>
                    <v-chip
                      v-else-if="
                        evento.status === 'E' && evento.desativar === 'N'
                      "
                      color="success"
                      avatar
                      small
                    >
                      <v-icon left small>mdi-check</v-icon>
                      <span>Publicado</span>
                    </v-chip>
                    <v-chip
                      v-else-if="
                        evento.status === 'C' && evento.desativar === 'N'
                      "
                      avatar
                      small
                    >
                      <v-icon left small>mdi-file-document-box-check</v-icon>
                      <span>Cadastrado</span>
                    </v-chip>
                    <v-chip
                      v-else-if="
                        evento.status === 'R' && evento.desativar === 'N'
                      "
                      avatar
                      small
                      dark
                    >
                      <v-icon left small>mdi-file-document-box-remove</v-icon>
                      <span>Reprovado</span>
                    </v-chip>
                    <v-chip
                      v-if="evento.enviar === '0'"
                      avatar
                      small
                      class="ml-2"
                    >
                      <v-icon left small>mdi-account</v-icon>
                      <span>Aluno</span>
                    </v-chip>
                    <v-chip
                      v-else-if="evento.enviar === '1'"
                      avatar
                      small
                      class="ml-2"
                    >
                      <v-icon left small>mdi-account-child</v-icon>
                      <span>Responsável</span>
                    </v-chip>
                    <v-chip
                      v-else-if="evento.enviar === '2'"
                      avatar
                      small
                      class="ml-2"
                    >
                      <v-icon left small>mdi-account-multiple</v-icon>
                      <span>Ambos</span>
                    </v-chip>
                  </header>
                </div>
              </v-card-title>
              <v-card-text>
                <div class="evento" v-html="evento.descricao"></div>
              </v-card-text>
              <v-card-text>
                <section>
                  <v-divider class="my-3" />
                  <p class="title primary--text">
                    <v-icon color="primary" left>mdi-attachment</v-icon>
                    <span>Anexo(s)</span>
                  </p>
                  <v-card-text
                    v-if="files && files.data && files.data.length > 0"
                  >
                    <v-chip
                      v-for="(file, index) in files.data"
                      :key="index"
                      label
                      outlined
                      class="mr-2"
                    >
                      <span
                        >Anexo {{ index + 1 }} ({{ file.split('.')[1] }})</span
                      >
                      <v-icon color="primary" @click="download(file)"
                        >mdi-file-eye-outline</v-icon
                      >
                      <v-icon
                        color="error"
                        @click="$refs.deteleFile.request(file)"
                        >mdi-delete</v-icon
                      >
                    </v-chip>
                  </v-card-text>
                  <p v-else>Nenhum arquivo para download.</p>
                </section>
                <section>
                  <v-divider class="my-3" />
                  <p class="title primary--text">
                    <v-icon color="primary" left>mdi-attachment</v-icon>
                    <span>Capa(s)</span>
                  </p>
                  <v-card-text
                    v-if="capas && capas.data && capas.data.length > 0"
                  >
                    <v-chip
                      v-for="(file, index) in capas.data"
                      :key="index"
                      label
                      outlined
                      class="mr-2"
                    >
                      <span
                        >Capa {{ index + 1 }} ({{ file.split('.')[1] }})</span
                      >
                      <v-icon color="primary" @click="download(file)"
                        >mdi-file-eye-outline</v-icon
                      >
                      <v-icon
                        color="error"
                        @click="$refs.deteleFile.request(file)"
                        >mdi-delete</v-icon
                      >
                    </v-chip>
                  </v-card-text>
                  <p v-else>Nenhum arquivo para download.</p>
                </section>
                <section class="mt-3">
                  <v-divider class="my-3" />
                  <p class="title primary--text">
                    <v-icon color="primary" left>mdi-calendar-clock</v-icon>
                    <span>Agenda</span>
                  </p>
                  <v-card-text
                    v-if="
                      agendados && agendados.data && agendados.data.length > 0
                    "
                  >
                    <v-simple-table dense>
                      <template v-slot:default>
                        <thead>
                          <tr>
                            <th class="text-left">Data</th>
                            <th class="text-left">Horário</th>
                            <th class="text-left">Excluir</th>
                          </tr>
                        </thead>
                        <tbody>
                          <tr v-for="item in agendados.data" :key="item.id">
                            <td>
                              {{
                                item.horario_data_envio.split(' ')[0] &&
                                  moment(
                                    item.horario_data_envio.split(' ')[0]
                                  ).format('DD/MM/YYYY')
                              }}
                            </td>
                            <td>{{ item.horario_data_envio.split(' ')[1] }}</td>
                            <td>
                              <v-btn
                                small
                                text
                                color="error"
                                @click="$refs.deleteAgenda.request(item.id)"
                              >
                                <v-icon lef>mdi-delete</v-icon>
                              </v-btn>
                            </td>
                          </tr>
                        </tbody>
                      </template>
                    </v-simple-table>
                  </v-card-text>
                  <p v-else>Nenhum evento agendado.</p>
                </section>
              </v-card-text>
            </v-card>
          </v-tab-item>
          <v-tab>Acompanhar Aluno</v-tab>
          <v-tab-item>
            <v-card>
              <v-card-title>
                <v-layout>
                  <v-flex md4 xs12 class="mr-3">
                    <v-text-field
                      v-model="filtros.search"
                      label="Procurar"
                    ></v-text-field>
                  </v-flex>
                  <v-checkbox
                    v-model="filtros.leu"
                    label="Lidos"
                    class="mr-2"
                  ></v-checkbox>
                  <v-checkbox
                    v-model="filtros.naoLeu"
                    label="Não Lidos"
                    class="mr-3"
                  ></v-checkbox>
                  <v-checkbox
                    v-model="filtros.confirmou"
                    label="Confirmados"
                    class="mr-3"
                  ></v-checkbox>
                  <v-checkbox
                    v-model="filtros.talvez"
                    label="Talvez"
                    class="mr-3"
                  ></v-checkbox>
                </v-layout>
                <v-layout wrap>
                  <div class="text-left">
                    <v-chip class="ma-1" color="primary" text-color="white">
                      <v-avatar left class="white--text">{{
                        contador.leu
                      }}</v-avatar
                      >Leu
                    </v-chip>
                    <v-chip class="ma-1" color="primary" text-color="white">
                      <v-avatar left class="white--text">{{
                        contador.naoLeu
                      }}</v-avatar
                      >Não Leu
                    </v-chip>
                    <v-chip class="ma-1" color="primary" text-color="white">
                      <v-avatar left class="white--text">{{
                        contador.confirmou
                      }}</v-avatar
                      >Confirmou
                    </v-chip>
                    <v-chip class="ma-1" color="primary" text-color="white">
                      <v-avatar left class="white--text">{{
                        contador.talvez
                      }}</v-avatar
                      >Talvez
                    </v-chip>
                    <v-chip class="ma-1" color="primary" text-color="white">
                      <v-avatar left class="white--text">{{
                        contador.ausentes
                      }}</v-avatar
                      >Ausentes
                    </v-chip>
                    <v-chip class="ma-1" color="primary" text-color="white">
                      <v-avatar left class="white--text">{{
                        contador.total
                      }}</v-avatar
                      >Total
                    </v-chip>
                  </div>
                </v-layout>
              </v-card-title>
              <v-data-table
                :headers="headers"
                :items="
                  tabela_acompanhar_aluno &&
                    tabela_acompanhar_aluno.dados &&
                    tabela_acompanhar_aluno.dados.data.length > 0 &&
                    tabela_acompanhar_aluno.dados.data
                "
                no-data-text="Não há comunicados disponíveis"
                no-results-text="Nenhuma comunicado encontrada"
                class="elevation-2"
                :loading="loadTabelaAcompAluno"
                :server-items-length="pagination.total"
                :options.sync="options"
                :footer-props="{
                  'items-per-page-options': [50, 100, 150, 200]
                }"
              >
                <template #body="{ items }">
                  <tbody>
                    <tr v-for="(item, id) in items" :key="id">
                      <td>{{ item.aluno }}</td>
                      <td v-if="item.leu == 'S'">
                        <v-icon color="success">mdi-check-bold</v-icon>
                      </td>
                      <td v-else>
                        <v-icon>mdi-close-circle</v-icon>
                      </td>
                      <td v-if="item.confirmou == 'S'">
                        <v-icon color="success">mdi-check-bold</v-icon>
                      </td>
                      <td v-else>
                        <v-icon>mdi-close-circle</v-icon>
                      </td>
                      <td>
                        {{
                          item.data_confirmacao &&
                            moment(item.data_confirmacao).format('DD/MM/YYYY')
                        }}
                      </td>
                    </tr>
                  </tbody>
                </template>
              </v-data-table>
            </v-card>
          </v-tab-item>
          <v-tab>Acompanhar Responsável</v-tab>
          <v-tab-item>
            <v-card>
              <v-card-title>
                <v-layout>
                  <v-flex md4 xs12 class="mr-3">
                    <v-text-field
                      v-model="filtros2.search"
                      label="Procurar"
                    ></v-text-field>
                  </v-flex>
                  <v-checkbox
                    v-model="filtros2.leu"
                    label="Lidos"
                    class="mr-2"
                  ></v-checkbox>
                  <v-checkbox
                    v-model="filtros2.naoLeu"
                    label="Não Lidos"
                    class="mr-3"
                  ></v-checkbox>
                  <v-checkbox
                    v-model="filtros2.confirmou"
                    label="Confirmados"
                    class="mr-3"
                  ></v-checkbox>
                  <v-checkbox
                    v-model="filtros2.talvez"
                    label="Talvez"
                    class="mr-3"
                    true-value="T"
                  ></v-checkbox>
                </v-layout>
                <v-layout wrap>
                  <div class="text-left">
                    <v-chip class="ma-1" color="primary" text-color="white">
                      <v-avatar left class="white--text">
                        {{ contador2.leu }} </v-avatar
                      >Leu
                    </v-chip>
                    <v-chip class="ma-1" color="primary" text-color="white">
                      <v-avatar left class="white--text">
                        {{ contador2.naoLeu }} </v-avatar
                      >Não Leu
                    </v-chip>
                    <v-chip class="ma-1" color="primary" text-color="white">
                      <v-avatar left class="white--text">
                        {{ contador2.confirmou }} </v-avatar
                      >Confirmou
                    </v-chip>
                    <v-chip class="ma-1" color="primary" text-color="white">
                      <v-avatar left class="white--text">
                        {{ contador2.talvez }} </v-avatar
                      >Talvez
                    </v-chip>
                    <v-chip class="ma-1" color="primary" text-color="white">
                      <v-avatar left class="white--text">
                        {{ contador2.ausentes }} </v-avatar
                      >Ausentes
                    </v-chip>
                    <v-chip class="ma-1" color="primary" text-color="white">
                      <v-avatar left class="white--text">
                        {{ contador2.total }} </v-avatar
                      >Total
                    </v-chip>
                  </div>
                </v-layout>
              </v-card-title>
              <v-data-table
                :headers="headers2"
                :items="
                  tabela_acompanhar_responsavel &&
                    tabela_acompanhar_responsavel.dados &&
                    tabela_acompanhar_responsavel.dados.data.length > 0 &&
                    tabela_acompanhar_responsavel.dados.data
                "
                no-data-text="Não há comunicados disponíveis"
                no-results-text="Nenhuma comunicado encontrado"
                class="elevation-2"
                :loading="loadTabelaAcompAluno"
                :options.sync="options2"
                :footer-props="{
                  'items-per-page-options': [50, 100, 150, 200]
                }"
              >
                <template #body="{ items }">
                  <tbody>
                    <tr v-for="(item, id) in items" :key="id">
                      <td>{{ item.responsavel }}</td>
                      <td>{{ item.aluno }}</td>
                      <td v-if="item.leu == 'S'">
                        <v-icon color="success">mdi-check-bold</v-icon>
                      </td>
                      <td v-else>
                        <v-icon>mdi-close-circle</v-icon>
                      </td>
                      <td v-if="item.confirmou == 'S'">
                        <v-icon color="success">mdi-check-bold</v-icon>
                      </td>
                      <td v-else>
                        <v-icon>mdi-close-circle</v-icon>
                      </td>
                      <td>
                        {{
                          item.data_confirmacao &&
                            moment(item.data_confirmacao).format('DD/MM/YYYY')
                        }}
                      </td>
                    </tr>
                  </tbody>
                </template>
              </v-data-table>
            </v-card>
          </v-tab-item>
        </v-tabs>
      </v-flex>
    </v-layout>

    <confirm ref="delete" :confirm-fn="remove"
      >Deseja excluir esta evento?</confirm
    >
    <confirm ref="deleteAgenda" :confirm-fn="deletar"
      >Deseja excluir esta agenda?</confirm
    >
    <confirm ref="deteleFile" :confirm-fn="excluirArquivo"
      >Deseja excluir este arquivo?</confirm
    >
    <v-snackbar v-model="snackbar" :color="cor ? cor : ''">
      {{ text }}
      <v-btn color="primary" text @click="snackbar = false">
        <v-icon>mdi-close</v-icon>
      </v-btn>
    </v-snackbar>
  </v-container>
</template>

<script>
import { Agenda, Anexos, Evento } from '../../service'
import Confirm from '../../components/Confirm'
export default {
  components: { Confirm },
  data() {
    return {
      overlay: false,
      cor: '',
      snackbar: false,
      text: '',
      dialog: false,
      id: this.$route.params.id,
      evento: {},
      escola: localStorage.getItem('escola')
        ? localStorage.getItem('escola')
        : '',
      date: new Date().toISOString().substr(0, 10),
      dateFormatted: this.formatDate(new Date().toISOString().substr(0, 10)),
      menu1: false,
      menu: false,
      time: this.moment().format('HH:mm'),
      menu2: false,
      modal2: false,
      agenda: {
        id_item: this.$route.params.id,
        funcao_id: '',
        horario_data_envio: this.date
      },
      agendados: [],
      files: { data: [] },
      capas: { data: [] },
      tabela_acompanhar_aluno: [],
      tabela_acompanhar_responsavel: [],
      loadTabelaAcompAluno: false,
      pagination: {
        current_page: 1,
        per_page: 5,
        total: 0
      },
      pagination2: {
        current_page: 1,
        per_page: 5,
        total: 0
      },
      filtros: {
        leu: '',
        confirmou: '',
        naoLeu: '',
        search: '',
        talvez: ''
      },
      filtros2: {
        leu: '',
        confirmou: '',
        naoLeu: '',
        search: '',
        talvez: ''
      },
      contador: {
        leu: '',
        naoLeu: '',
        confirmou: '',
        total: '',
        talvez: '',
        ausentes: ''
      },
      contador2: {
        leu: '',
        naoLeu: '',
        confirmou: '',
        total: '',
        talvez: '',
        ausentes: ''
      },
      options: {},
      options2: {},
      headers: [
        {
          text: 'Aluno',
          value: 'aluno'
        },
        {
          text: 'Leu',
          value: 'leu'
        },
        {
          text: 'Confirmou',
          value: 'confirmou'
        },
        {
          text: 'Data Confirmação',
          value: 'data_confirmacao'
        }
      ],
      headers2: [
        {
          text: 'Responsável',
          value: 'responsavel'
        },
        {
          text: 'Aluno',
          value: 'aluno'
        },
        {
          text: 'Leu',
          value: 'leu'
        },
        {
          text: 'Confirmou',
          value: 'confirmou'
        },
        {
          text: 'Data Confirmação',
          value: 'data_confirmacao'
        }
      ]
    }
  },
  computed: {
    computedDateFormatted() {
      return this.formatDate(this.date)
    }
  },
  watch: {
    $route(to) {
      this.id = to.params.id
    },
    date() {
      this.dateFormatted = this.formatDate(this.date)
    },
    options: {
      deep: true,
      async handler() {
        await this.tableAcompAluno()
      }
    },
    options2: {
      deep: true,
      async handler() {
        await this.tableAcompResponsavel()
      }
    },
    filtros: {
      deep: true,
      async handler() {
        await this.tableAcompAluno()
      }
    },
    filtros2: {
      deep: true,
      async handler() {
        await this.tableAcompResponsavel()
      }
    }
  },
  async created() {
    await this.load()

    this.contador.leu = this.tabela_acompanhar_aluno.totais.totalLeu
    this.contador.naoLeu = this.tabela_acompanhar_aluno.totais.totalNaoLeu
    this.contador.confirmou = this.tabela_acompanhar_aluno.totais.totalConfirmou
    this.contador.total = this.tabela_acompanhar_aluno.totais.total
    this.contador.talvez = this.tabela_acompanhar_aluno.totais.totalTalvez
    this.contador.ausentes = this.tabela_acompanhar_aluno.totais.totalAusente

    this.contador2.leu = this.tabela_acompanhar_responsavel.totais.totalLeu
    this.contador2.naoLeu = this.tabela_acompanhar_responsavel.totais.totalNaoLeu
    this.contador2.confirmou = this.tabela_acompanhar_responsavel.totais.totalConfirmou
    this.contador2.total = this.tabela_acompanhar_responsavel.totais.total
    this.contador2.talvez = this.tabela_acompanhar_responsavel.totais.totalTalvez
    this.contador2.ausentes = this.tabela_acompanhar_responsavel.totais.totalAusente
  },
  methods: {
    async remove() {
      await Evento.delete(this.evento.id, { escola: this.escola })
      this.$router.back()
    },
    async load() {
      this.overlay = true
      this.evento = await Evento.findById(this.id, {
        escola: this.escola
      })
      await this.tableAcompAluno()
      await this.tableAcompResponsavel()
      await this.loadFiles()
      this.agenda.funcao_id = this.evento.funcao_id
      await this.load_table()
      this.overlay = false
    },
    async tableAcompAluno() {
      this.loadTabelaAcompAluno = true
      try {
        // const { sortBy, sortDesc, page, itemsPerPage } = this.options
        let confirmou = false
        if (this.filtros.talvez == 'T' || this.filtros.talvez == true) {
          confirmou = 'T'
        } else {
          if (this.filtros.confirmou == false) {
            confirmou = ''
          } else {
            confirmou = true
          }
        }
        this.tabela_acompanhar_aluno = await Evento.exibirComunicacaoAluno(
          this.evento.id,
          {
            search: this.filtros.search,
            leu: this.filtros.leu == false ? '' : true,
            naoLeu: this.filtros.naoLeu == false ? '' : true,
            confirmou: confirmou,
            per_page: this.options.itemsPerPage,
            page: this.options.page,
            order: this.options.sortBy ? this.options.sortBy[0] : '',
            dir: this.options.sortDesc == true ? 'DESC' : 'ASC',
            escola: this.escola
          }
        )
        this.pagination.total = this.tabela_acompanhar_aluno.dados.total
        this.pagination.current_page = this.tabela_acompanhar_aluno.dados.current_page
        this.pagination.per_page = parseInt(
          this.tabela_acompanhar_aluno.dados.per_page
        )
      } catch (erro) {
        //console.log(erro)
        this.loadTabelaAcompAluno = false
        this.snackbar = true
        this.text = 'Erro ao carregar a tabela de acompanhamento de aluno'
        this.cor = 'red'
      }
      this.loadTabelaAcompAluno = false
    },
    async tableAcompResponsavel() {
      this.loadTabelaAcompAluno = true
      let confirmou = false
      if (this.filtros.talvez == 'T' || this.filtros.talvez == true) {
        confirmou = 'T'
      } else {
        if (this.filtros.confirmou == false) {
          confirmou = ''
        } else {
          confirmou = true
        }
      }
      try {
        this.tabela_acompanhar_responsavel = await Evento.exibirComunicacaoResponsavel(
          this.evento.id,
          {
            search: this.filtros2.search,
            leu: this.filtros2.leu == false ? '' : true,
            naoLeu: this.filtros2.naoLeu == false ? '' : true,
            confirmou: confirmou,
            per_page: this.options2.itemsPerPage,
            page: this.options2.page,
            order: this.options2.sortBy ? this.options2.sortBy[0] : '',
            dir: this.options2.sortDesc == true ? 'DESC' : 'ASC',
            escola: this.escola
          }
        )
        this.pagination2.total = this.tabela_acompanhar_aluno.dados.total
        this.pagination2.current_page = this.tabela_acompanhar_responsavel.dados.current_page
        this.pagination2.per_page = parseInt(
          this.tabela_acompanhar_responsavel.dados.per_page
        )
      } catch (erro) {
        this.loadTabelaAcompAluno = false
        this.snackbar = true
        this.text = 'Erro ao carregar tabela de responsaveis'
        this.cor = 'red'
      }
      this.loadTabelaAcompAluno = false
    },
    async desativar(novoStatus) {
      this.evento = await Evento.desativar(
        this.evento.id,
        novoStatus,
        this.escola
      )
      await this.load()
    },
    async enviar() {
      try {
        await Evento.enviar(
          this.evento.id,
          this.evento.turma.map(({ id }) => id),
          { escola: this.escola }
        )
        this.snackbar = true
        this.text = 'Evento enviado com sucesso'
      } catch (e) {
        this.snackbar = true
        this.text = 'Houve um erro ao enviar o evento'
        this.cor = 'red'
      }
      await this.load()
    },
    formatDate(date) {
      if (!date) return null

      const [year, month, day] = date.split('-')
      return `${day}/${month}/${year}`
    },
    parseDate(date) {
      if (!date) return null

      const [month, day, year] = date.split('/')
      return `${year}-${month.padStart(2, '0')}-${day.padStart(2, '0')}`
    },
    async desativarPorId() {
      this.evento = await Evento.desativarPorID(this.evento.id, this.escola)
    },
    async agendar() {
      this.agenda.horario_data_envio = this.date + ' ' + this.time
      await Agenda.save(this.agenda, { escola: this.escola })
      this.dialog = false
      this.load_table()
    },
    async deletar(id) {
      await Agenda.delete(id, { escola: this.escola })
      this.load_table()
    },
    async load_table() {
      this.agendados = await Agenda.atividadesAgendadas(
        this.evento.id,
        this.evento.funcao_id,
        this.escola
      )
    },
    async download(url) {
      const getFile = await Anexos.getURL(url, this.escola)
      window.open(getFile.data, '_blank')
    },
    async excluirArquivo(url) {
      const deletedFile = await Anexos.deteleFile({
        pathFile: url,
        escola: this.escola
      })
      if (deletedFile) {
        this.loadFiles()
      }
    },
    async loadFiles() {
      this.files = await Evento.getAnexos(this.evento.id, this.escola)
      this.capas = await Evento.getCapas(this.evento.id, this.escola)
    }
  }
}
</script>

<style></style>
